import { render, staticRenderFns } from "./ConfigAlertTheHive.vue?vue&type=template&id=44b87305&"
import script from "./ConfigAlertTheHive.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertTheHive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports